var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Checkbox-01__Icn/40px/Checkbox-01",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,14 L26,26 L14,26 L14,14 L26,14 Z M24,16 L16,16 L16,24 L24,24 L24,16 Z",
    id: ".._.._src_svg_Icn_40px_Checkbox-01__Rectangle-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox01);
export default __webpack_public_path__ + "static/media/Checkbox-01.ed7d11f6c5e30c45c6308bfdb9a335f7.svg";
export { ForwardRef as ReactComponent };